export default __webpack_public_path__ + "static/media/content-energy-efficiency.0d8f3370.svg";